import React from "react";
import { Line } from "react-chartjs-2";

// reactstrap components
import { Card, CardBody, CardHeader, Row, CardText, Col} from "reactstrap";

const LineCardPresentational = (props) => {
    const style={
        chartCol:{
            height:"25rem",
        }
    }
    const options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: false,
                    callback:function(value){
                        return value;
                    }
                },
            }],
        },
      }
    return (
        <Card>
            <CardHeader>
                <CardText className="mb-0 mt-0" style={props.style.cardHeaderText}>
                    {props.textCardHeader}
                </CardText>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xl="12" style={style.chartCol}>
                        <Line data={props.data} options={options}/>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}


export default LineCardPresentational;